import {
  MetricSummaryCard,
  type MetricSummaryCardProps,
} from '../MetricSummaryCard/MetricSummaryCard';

/**
 * Figma `972:20768`.
 *
 * The supporting line lost Overview's "the chart further down this page" and
 * names the card instead. The sentence was true of Overview and would have been
 * a guess anywhere else — a report holding this figure need not also hold the
 * history, and a card cannot see what else is on the page with it.
 *
 * `helpSupportingText` is a note on what this workspace's count leaves out,
 * when its source leaves something out.
 */
export function TotalMentionsCard({
  helpSupportingText,
  ...props
}: MetricSummaryCardProps & { helpSupportingText?: string }) {
  return (
    <MetricSummaryCard
      {...props}
      copy={{
        title: 'Total mentions',
        helpText:
          'Shows the number of monitored mentions of your brand and keywords during the selected period. This measures conversation volume, regardless of how many people saw each mention.',
        helpSupportingText,
      }}
    />
  );
}
